import { DateTime } from 'luxon';
import { Filters } from './Common';

export class drMicroEvent {
    MicroID: number;
    MicroGUID: string;
    ContactID: number;
    ParentID: number; // risposta a questo feedback
    ID1: number;
    ID2: number;
    ID3: number;
    Type1: string;
    Type2: string;
    Type3: string;
    Lang: string;
    MicroType: string;
    D: (DateTime | null)[];
    C: boolean[]; // 4
    T: string[]; // 8
    M: string[]; // 4
    N: number[]; // 31
    Created: DateTime | null;
    CreatedBy: string;

    constructor() {
        this.MicroID = 0;
        this.MicroGUID = '';
        this.ContactID = 0;
        this.ParentID = 0; // risposta a questo feedback
        this.ID1 = 0;
        this.ID2 = 0;
        this.ID3 = 0;
        this.Type1 = '';
        this.Type2 = '';
        this.Type3 = '';
        this.Lang = '';
        this.MicroType = '';
        this.D = [null, null, null, null];
        this.C = [false, false, false, false]; // 4
        this.T = ['', '', '', '', '', '', '', '']; // 8
        this.M = ['', '', '', '']; // 4
        this.N = [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0
        ]; // 31
        this.Created = null;
        this.CreatedBy = '';
    }
}

export class CreateMicroEventsReq {
    myToken: string;
    microEvent: drMicroEvent | null;

    constructor() {
        this.myToken = '';
        this.microEvent = null;
    }
}

export class GetMicroEventsReq {
    myToken: string;
    filters: Filters | null;
    orderBy: string;

    constructor() {
        this.myToken = '';
        this.orderBy = '';
        this.filters = null;
    }
}

export class GetMicroEventsResp {
    error: string;
    microEvents: drMicroEvent[] | null;

    constructor() {
        this.error = '';
        this.microEvents = null;
    }
}

export class GetEventReq {
    myToken: string;
    eventId: number;

    constructor() {
        this.myToken = '';
        this.eventId = 0;
    }
}

export class GetMicroEventReq {
    myToken: string;
    store: string;
    microId: number;
    ID1: number;
    ID2: number;
    ID3: number;
    microType: string;

    constructor() {
        this.myToken = '';
        this.store = '';
        this.microId = 0;
        this.ID1 = 0;
        this.ID2 = 0;
        this.ID3 = 0;
        this.microType = '';
    }
}

export class MicroEventResp {
    error: string;
    microEvent: drMicroEvent | null;
    giorniFestivi: number[];

    constructor() {
        this.error = '';
        this.microEvent = null;
        this.giorniFestivi = [];
    }
}

export class SetMicroEventReq {
    myToken: string;
    microEvent: drMicroEvent | null;
    fields: string;

    constructor() {
        this.myToken = '';
        this.microEvent = null;
        this.fields = '';
    }
}